import { Checkbox, Col, Form, Input, notification, Select } from "antd";
import { listagemActions, manutencaoActions, selectPaginadoActions } from "../../actions";
import { FormularioDinamico, SelectPaginacao } from "../../components";
import DrawerTipoEquipamento from "../tipoEquipamento/drawer";
import DrawerModeloEquipamento from "../modeloEquipamento/drawer";
import api from "../../services/api";
import { useStateValue } from "../../state";
import { useEffect, useState } from "react";
import DrawerMarca from "../marca/drawer";

export default function ManutencaoEquipamentoCliente({ formulario, carregando, aoSalvar, carregarEquipamentos }) {

    const [{ ui, manutencao }, dispatch] = useStateValue();
    const [loading, setLoading] = useState(false);
    const [hover, setHover] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [openDrawerTipoEquipamento, setOpenDrawerTipoEquipamento] = useState(false);
    const [openDrawerModelo, setOpenDrawerModelo] = useState(false);
    const [listaIdentificacao, setIdentificacao] = useState([]);
    const [tipoIdentificacao, setTipoIdentificacao] = useState();
    const [openDrawerMarca, setOpenDrawerMarca] = useState(false);


    useEffect(() => {
        formulario.setFieldsValue({ eqp_tipoidentificacao: 0 })
        if (tipoIdentificacao === 0) {
            formulario.setFieldsValue({ eqp_identificacao: "" });
        }
    }, [tipoIdentificacao, formulario]);

    useEffect(() => {
        api.get(`Enum/Listar?nome=OsTipoIdentificacao`).then(res => {
            if (res.status === 200) {
                setIdentificacao(res.data);
            }
        }).catch((erro) => console.error(erro));

    }, []);


    const salvarManutencao = (values) => {
        if (!values.eqp_descricao) {
            notification.warning({ message: 'Descrição do Equipamento não informada!', description: 'Por favor, Informe a Descrição.', });
            return;
        } if (!values.teq_id) {
            notification.warning({ message: 'Tipo de Equipamento não informado!', description: 'Por favor, Informe o Tipo de Equipamento.', });
            return;
        } if (values.eqp_tipoidentificacao === undefined || values.eqp_tipoidentificacao === null) {
            notification.warning({ message: 'Tipo de Identificação do Equipamento não informado!', description: 'Por favor, Informe o Tipo de Identificação do Equipamento.', });
            return;
        } if ((values.eqp_tipoidentificacao === 1 || values.eqp_tipoidentificacao === 2) && !values.eqp_identificacao) {
            notification.warning({
                message: 'Identificação não informada!',
                description: 'Por favor, preencha a Identificação do Equipamento (ex: IMEI, SERIAL).',
            });
            return;
        }
        if (values.eqp_tipoidentificacao === 0 || values.eqp_tipoidentificacao === undefined) {
            values.eqp_identificacao = "";
        }
        if ((values.eqp_tipoidentificacao === 1 || values.eqp_tipoidentificacao === 2) && !values.eqp_identificacao) {
            notification.warning({
                message: 'Identificação não informada!',
                description: 'Por favor, preencha a Identificação do Equipamento (ex: IMEI, SERIAL).',
            });
            return;
        }
        carregando(true);
        values.cli_id = formulario.getFieldValue("cli_id");
        values.eqp_senhapin = formulario.getFieldValue().eqp_senhapin;
        values.teq_exigeidentificacao = formulario.getFieldValue().teq_exigeidentificacao;
        let retorno;

        let enderecoUrl = 'EquipamentoCliente/';

        if (values.eqp_id) {
            enderecoUrl += `Editar`;
            api.put(enderecoUrl, values).then(res => {
                if (res.status === 200) {
                    notification.success({ message: 'Operação concluída', description: "Equipamento alterado com sucesso!" });
                    retorno = res.data;
                }
            }, err => {
                notification.error({ message: 'Erro ao processar a requisição.', description: JSON.stringify(err.response) });
            }).finally(
                () => {
                    carregando(false);
                    aoSalvar(retorno);
                    carregarEquipamentos();
                    setFileList([]);
                })
        } else {
            enderecoUrl += `Incluir`;
            api.post(enderecoUrl, values).then(res => {
                if (res.status === 200) {
                    notification.success({ message: 'Operação concluída', description: "Novo Equipamento incluído com sucesso!" });
                    retorno = res.data;
                    dispatch({ type: manutencaoActions.CHANGE, data: { dados: res.data } });
                }
            }, err => {
                notification.error({ message: 'Erro ao processar a requisição.', description: JSON.stringify(err.response) });
            }).finally(
                () => {
                    carregando(false);
                    aoSalvar(retorno);
                    carregarEquipamentos();
                }
            );
        }
    }

    async function preencherTipoIdenti(value) {
        try {
            let tipoEquipamento = await api.get(`TipoEquipamento/Listar?Codigo=${value}`);
            let identificacoes = tipoEquipamento.data.items;
            let identificacao = identificacoes.find(item => item.teq_id == value);
            if (identificacao && identificacao.teq_exigeidentificacao !== undefined) {
                formulario.setFieldsValue({
                    eqp_tipoidentificacao: identificacao.teq_exigeidentificacao,
                });
            }
        } catch (error) {
            console.error('Erro ao buscar tipo de equipamento:', error);
        }
    }

    function salvandoDadosModelo(retorno) {
        let lista = [];
        if (retorno) {
            lista.push({ name: "meq_id", campo: "Codigo", value: retorno.meq_id });
            dispatch({ type: selectPaginadoActions.CHANGE, data: { itens: lista } });
            formulario.setFieldsValue({ meq_id: retorno.meq_id });
        }
    }
    function salvandoDadosTipo(retorno) {
        let lista = [];
        if (retorno) {
            lista.push({ name: "teq_id", campo: "CodigoTipo", value: retorno });
            dispatch({ type: selectPaginadoActions.CHANGE, data: { itens: lista } });
            formulario.setFieldsValue({ teq_id: retorno.teq_id});
        }
    }
    function salvandoDadosMarca(retorno) {
        let lista = [];
        if (retorno) {
            lista.push({ name: "mar_id", campo: "Codigo", value: retorno.mar_id });
            dispatch({ type: selectPaginadoActions.CHANGE, data: { itens: lista } });
            formulario.setFieldsValue({mar_id: retorno.mar_id});
        }
    }
    return (
        <Form layout="vertical" form={formulario} name="TabEquipamentoCliente" onFinish={salvarManutencao}>

            <Form.Item name="eqp_id" hidden={true}> <Input /> </Form.Item>

            <Col span={15}>
                <Form.Item label="Descrição do Equipamento" name="eqp_descricao" rules={[{ required: true, message: 'Informe a Descrição do Equipamento' },]}>
                    <Input
                        placeholder="Digite a Descrição do Equipamento" />
                </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={13} lg={13} xl={13}>
                <Form.Item label="Tipo de Equipamento" name="teq_id" rules={[{ required: true, message: 'Informe o Tipo de Equipamento' },]}>
                    <SelectPaginacao url="TipoEquipamento/Listar"
                        allowClear={true}
                        selecionarRegUnico={"teq_id"}
                        nameLabel="teq_descricao"
                        nameValue="teq_id"
                        placeholder="Selecione o Tipo de Equipamento"
                        form={formulario}
                        funcaoIncluir={() => setOpenDrawerTipoEquipamento(true)}
                        onChangeFunction={(value) => preencherTipoIdenti(value)}
                    />
                </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={13} lg={13} xl={13}>
                <Form.Item label="Marca" name="mar_id">
                    <SelectPaginacao url="marca/Listar?Ativa=true"
                        allowClear={true}
                        // selecionarRegUnico={"mar_id"}
                        nameLabel="mar_nome"
                        nameValue="mar_id"
                        placeholder="Selecione a Marca"
                        form={formulario}
                        funcaoIncluir={() => setOpenDrawerMarca(true)}
                    />
                </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={13} lg={13} xl={13}>
                <Form.Item label="Modelo Equipamento" name="meq_id">
                    <SelectPaginacao url="ModeloEquipamento/Listar"
                        allowClear={true}
                        selecionarRegUnico={"meq_id"}
                        nameLabel="meq_descricao"
                        nameValue="meq_id"
                        placeholder="Selecione o Modelo do Equipamento"
                        form={formulario}
                        funcaoIncluir={() => setOpenDrawerModelo(true)}
                    />
                </Form.Item>
            </Col>
            <Col xs={24} sm={8} md={6} lg={6} xl={6}>
                <Form.Item label="Tipo de Identificação do Equipamento" name="eqp_tipoidentificacao" rules={[{ required: true }]}>
                    <Select showSearch optionFilterProp="children" placeholder="Selecione o Tipo de Identificação do Equipamento"
                        onChange={(value) => {
                            setTipoIdentificacao(value);
                            formulario.setFieldsValue({ eqp_identificacao: value === 0 ? "" : formulario.getFieldValue("eqp_identificacao") });
                        }}
                        filterOption={(input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0} >
                        {listaIdentificacao?.map(item => (
                            <Select.Option key={item.key} value={item.key}> {`${item.key} - ${item.value}`} </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={13} lg={13} xl={13}>
                <Form.Item label="Identificação" name="eqp_identificacao" rules={(tipoIdentificacao === 1 || tipoIdentificacao === 2) ? [{ required: true, message: 'Por favor, preencha a identificação.' }] : []}>
                    <Input placeholder="EX: IMEI, SERIAL..."
                        disabled={tipoIdentificacao === 0 || tipoIdentificacao === undefined}
                    />
                </Form.Item>
            </Col>
            <Col span={10}>
                <Form.Item label="Senha do Aparelho" name="eqp_senhapin">
                    <Input
                        placeholder="Digite a senha do aparelho" />
                </Form.Item>
            </Col>
            {openDrawerTipoEquipamento && (
                <DrawerTipoEquipamento fecharSomenteDrawer={true} openDrawer={openDrawerTipoEquipamento} setOpenDrawer={setOpenDrawerTipoEquipamento} cadTipoEquipamento={false}
                    retornoSalvar={salvandoDadosTipo} />
            )}
            <Col xs={10} sm={6} md={4} lg={4} xl={4}>
                <Form.Item name="eqp_ativo" initialValue={true} valuePropName="checked" className="t-mob-573">
                    <Checkbox>Equipamento Ativo</Checkbox>
                </Form.Item>
            </Col>
            {openDrawerModelo && (
                <DrawerModeloEquipamento openDrawer={openDrawerModelo} setOpenDrawer={setOpenDrawerModelo} cadModelo={false} retornoSalvar={salvandoDadosModelo} />
            )}
            {openDrawerMarca && (
                <DrawerMarca openDrawer={openDrawerMarca} setOpenDrawer={setOpenDrawerMarca} cadMarca={false} retornoSalvar={salvandoDadosMarca} />
            )}
        </Form >
    )
}